import React from 'react'
import { Trans } from '@lingui/react/macro'

interface IEmailLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}
export const EmailLink: React.FC<IEmailLinkProps> = (props) => {
  return (
    <a
      {...props}
      href='mailto:support@tad.ai'
      rel='nofollow noreferrer'
      className='text-f-primary hover:underline'
    >
      support@tad.ai
    </a>
  )
}

export const TermsLink: React.FC<IEmailLinkProps> = (props) => {
  return (
    <Link
      className='text-f-primary hover:underline'
      href={'/terms'}
      rel='nofollow noreferrer'
      {...props}
    >
      <Trans>Terms of Use</Trans>
    </Link>
  )
}

export const RefundPolicyLinks: React.FC<IEmailLinkProps> = (props) => {
  return (
    <Link
      className='text-f-primary hover:underline'
      href={'/refund-policy'}
      rel='nofollow noreferrer'
      {...props}
    >
      <Trans>our Refund Policy page</Trans>
    </Link>
  )
}

export const PrivacyPolicyLinks: React.FC<IEmailLinkProps> = (props) => {
  return (
    <Link
      className='text-f-primary ms-1 hover:underline'
      href={'/privacy'}
      rel='nofollow noreferrer'
      {...props}
    >
      <Trans>Privacy Policy</Trans>
    </Link>
  )
}

interface SiteLinkProps {
  text?: string
  href?: string
}
export const SiteLink = (props: SiteLinkProps) => {
  const { text, href, ...restProps } = props
  return (
    <Link
      className='text-f-primary hover:underline'
      href={href || 'https://tad.ai'}
      rel='nofollow noreferrer'
      {...restProps}
    >
      {text || 'Tad.AI'}
    </Link>
  )
}
